// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"fa6f7a99","336":"ed0231a0","453":"4ba3ecfd","564":"d184f3c2","756":"f4fddff2","786":"8e8e88a1","900":"065b13bd","961":"c12ae91c","975":"7a3b713c"}[chunkId] + ".chunk.js";
};